<template>
  <div class="pins">
    <van-overlay :show="show">
      <div class="wrapper" @click.stop>
        <van-loading size="24px" vertical>加载中...</van-loading>
      </div>
    </van-overlay>
    <van-sticky>
      <van-tabs v-model="index">
        <van-tab
          v-for="list in tab"
          :key="list.name"
          :title="list.title"
          :name="list.name"
        ></van-tab>
      </van-tabs>
    </van-sticky>
    <div class="magtop">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="木有更多了~"
          @load="onLoad"
          class="bai di mtop"
        >
          <van-row
            gutter="10"
            class="mag"
            v-for="(list,index) in courlist"
            :key="index"
            @click="courseparams(list.courseId,list.courseTypeid)"
          >
            <van-col span="8" class="posjhu">
              <img
                :src="list.serverHttp+list.courseImg"
                width="100%"
                class="kecimg"
                v-if="list.courseImg"
              />
              <img
                src="../../assets/img/zbmr.png"
                width="100%"
                class="kecimg"
                v-else
              />
              <span class="fpoad-span" v-if="list.courseTypeid==2">{{list.lessonCnt}}课时</span>
              <span class="fpoad-span" v-if="list.courseTypeid==1">直播课</span>
            </van-col>
            <van-col span="16">
              <van-col span="24" class="gaodu">
                {{ list.courseName }}
              </van-col>
              <van-col span="24">
                <van-col span="24" class="spanhong">
                  <!-- <span class="lanm biao-span">{{ list.schoolName }}</span> -->
                  <span class="magtop chefudui huisezi"
                    >{{ list.createTime }}</span
                  >
                </van-col>
              </van-col>
            </van-col>
          </van-row>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-empty
      class="custom-image"
      :image="img"
      v-if="courlist.length == 0"
      description="暂时没有观课记录"
    />
    <!-- <dibu class="dibu"></dibu> -->
  </div>
</template>

<script>
import { courseclassify ,notelist,courseparams} from "@/api/home";
import { Toast } from "vant";
export default {
  data() {
    return {
      show: false,
      loading: false,
      index:"0",
      finished: false,
      refreshing: false,
      isLoading: false,
      img: require("../../assets/img/kong.png"),
      curPage: 0,
      courlist: [],
      imglist: [
        { advImg: require("../../assets/img/lunb.png"), id: 0 },
        { advImg: require("../../assets/img/lunb.png"), id: 1 },
      ],
      tab: [],
      imgs:'https://file.51xiaoping.com/',
      ishju:true
    };
  },
  watch: {
    index(){
      this.ishju=true
      this.onRefresh()
    }
  },
  components: {  },
  methods: {
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.courlist = [];
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.curPage = 1;
      this.ishju=true
      this.notelist();
    },
    onLoad() {
      if(this.ishju){
        this.curPage++;
        this.notelist();
      }
    },
    notelist() {
      let that = this;
      that.show = true;
      let params = {
        curPage: this.curPage,
        pageSize: 10,
        courseState: 1,
        courseTypeid: 2,
        groupId: 1,
        courseClassify:this.index
      };
      this.isLoading = true;
      notelist(params)
        .then((res) => {
          for (var i = 0; i < res.data.data.dataList.length; i++) {
            that.courlist.push(res.data.data.dataList[i]);
          }
          if (that.courlist.length >= res.data.data.totalCount) {
            that.finished = true;
          }
          if(res.data.data.totalCount==0){
             that.ishju=false
             that.finished = false;
          }
          that.isLoading = false;
          that.loading = false;
          that.show = false;
        })
        .catch(() => {
          that.loading = false;
          that.show = false;
        });
    },
    courseclassi(){
      let that = this;
      that.show = true;
      courseclassify()
        .then((res) => {
          that.list=res.data.data
          let tab = [{ title: "全部", name: "0" }];
          for (var i = 0; i < res.data.data.length; i++) {
            let list = {
              title: res.data.data[i].classifyName,
              name: res.data.data[i].id.toString(),
            };
            tab.push(list);
          }
          that.tab = tab;
         that.show = false;
        })
        .catch(() => {
          that.show = false;
        });
    },
    courseparams(s,d){
      let that = this;
       let params = {
        id: s,
      };
      courseparams(params)
        .then((res) => {
          let id=res.data.data.lessonVos[0].lessonId
          if(d==2){
            that.$router.push({
            path: "/indexvideo",
            query: {
              id: id,
            },
          });
          }else{
            that.$router.push({
            path: "/video",
            query: {
              id: id,
              t: Date.now()
            },
          });
          }
        })
        .catch(() => {

        });
    }
  },
  mounted() {
    this.courseclassi()
    this.$nextTick(() => {
     if(this.$route.query.id){
          this.index=this.$route.query.id?this.$route.query.id.toString():'0'
      }
    })
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/index/record.vue